import { createGlobalStyle } from 'styled-components'
import { ITheme } from 'theme/theme'

export const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    background: ${({ theme }: { theme: ITheme }) => theme.body};
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
    font-family: ${({ theme }: { theme: ITheme }) => theme.fontFamily};
  }
  a {color: ${({ theme }: { theme: ITheme }) => theme.linkColor};}
  a:hover {color:${({ theme }: { theme: ITheme }) => theme.linkHoverColor};}
  .text-muted {
    color: ${({ theme }: { theme: ITheme }) => theme.textMuted} !important;
  }
  .textHighlight {background: ${({ theme }: { theme: ITheme }) => theme.textHightlight}}
  .list-group-item {
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
    background-color: ${({ theme }: { theme: ITheme }) => theme.bgLight};
    border: var(--bs-list-group-border-width) solid ${({ theme }: { theme: ITheme }) => theme.border};
  }
  .bgi-white{background-color:${({ theme }: { theme: ITheme }) => theme.bgImageButtonBG}}
  .bgi-white:hover{color:#000;background-color:${({ theme }: { theme: ITheme }) => theme.bgImageButtonBG}}

  .form-control:disabled {
    background-color: ${({ theme }: { theme: ITheme }) => theme.disabledInputBG};
  }

  .alert-info {
    --bs-alert-color: ${({ theme }: { theme: ITheme }) => theme.infoAlertTextColor};
    --bs-alert-bg: ${({ theme }: { theme: ITheme }) => theme.infoAlertBG};
    --bs-alert-border-color: ${({ theme }: { theme: ITheme }) => theme.infoAlertBorder};
  }

  // Sortable Items ###########################################################
  .sortableItem {
    background-color: ${({ theme }: { theme: ITheme }) => theme.sortableItemBG};
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
    border: solid 1px ${({ theme }: { theme: ITheme }) => theme.border};
  }
  // ##########################################################################

  // Bootstrap Overrides - bg-light & bg-white backgrounds, border & text #####
  .bg-light {
    background-color: ${({ theme }: { theme: ITheme }) => theme.bgLight} !important;
  }
  .navbar-light .navbar-nav .nav-link {
    color: ${({ theme }: { theme: ITheme }) => theme.navTextColor};
  }
  .bg-white {
    background-color: ${({ theme }: { theme: ITheme }) => theme.bgWhite} !important;
  }
  .text-dark {
    color: ${({ theme }: { theme: ITheme }) => theme.textColor}, var(--bs-text-opacity)) !important;
  }
  .border-bottom {
    border-bottom: solid 1px  ${({ theme }: { theme: ITheme }) => theme.border} !important;
  }
  .border-end {
    border-right: solid 1px ${({ theme }: { theme: ITheme }) => theme.border} !important;
  }
  .border-start {
    border-left: solid 1px ${({ theme }: { theme: ITheme }) => theme.border} !important;
  }
  .border {
    border: 1px solid ${({ theme }: { theme: ITheme }) => theme.border} !important;
  }
  .border-top {
    border-top: var(--bs-border-width) var(--bs-border-style) ${({ theme }: { theme: ITheme }) => theme.border} !important;
  }
  .input-group-text {
    background-color: ${({ theme }: { theme: ITheme }) => theme.inputPrefixBG};
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
    border: ${({ theme }: { theme: ITheme }) => theme.border};
  }
  // #########################################################################

  // Buttons #################################################################
  .btn-default {
    color: ${({ theme }: { theme: ITheme }) => theme.buttonDefaultColor} !important;
    background-color: ${({ theme }: { theme: ITheme }) => theme.buttonDefaultBG} !important;
    border-color: ${({ theme }: { theme: ITheme }) => theme.buttonDefaultBorder} !important;
  }
  .btn-default:hover {
    color: ${({ theme }: { theme: ITheme }) => theme.buttonDefaultHoverColor} !important;
    background-color: ${({ theme }: { theme: ITheme }) => theme.buttonDefaultHoverBG} !important;
    border-color: ${({ theme }: { theme: ITheme }) => theme.buttonDefaultHoverBorder} !important;
  }
  // #####################################################################

  //Menu & SideBar #######################################################
  #StickyHeaderWrapper.sticky-header {
    background: ${({ theme }: { theme: ITheme }) => theme.body} !important;
  }
  #DealersEditPage .flex-left, 
  #InventoryEditPage .flex-left, 
  #SignUpEditPage .flex-left, 
  #LeadEditPage .flex-left,
  #EmployeeEditPage .flex-left,
  #CasesEditPage .flex-left {
    background: ${({ theme }: { theme: ITheme }) => theme.invSideBarBG} !important;
    border: solid 1px ${({ theme }: { theme: ITheme }) => theme.invSideBarBorder} !important;
  }
  #DealersEditPage .sidenav button.dropdown-btn.active, 
  #InventoryEditPage .sidenav button.dropdown-btn.active, 
  #SignUpEditPage .sidenav button.dropdown-btn.active, 
  #LeadEditPage .sidenav button.dropdown-btn.active,
  #EmployeeEditPage .sidenav button.dropdown-btn.active,
  #CasesEditPage .sidenav button.dropdown-btn.active {
    background: ${({ theme }: { theme: ITheme }) => theme.invSideBarDropdownActiveBG} !important;
    border-bottom: solid 1px ${({ theme }: { theme: ITheme }) => theme.invSideBarDropdownActiveBorder} !important;
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
  }
  #DealersEditPage .sidenav button.dropdown-btn.active:hover, 
  #InventoryEditPage .sidenav button.dropdown-btn.active:hover, 
  #SignUpEditPage .sidenav button.dropdown-btn.active:hover, 
  #LeadEditPage .sidenav button.dropdown-btn.active:hover,
  #EmployeeEditPage .sidenav button.dropdown-btn.active:hover,
  #CasesEditPage .sidenav button.dropdown-btn.active:hover {
    background: ${({ theme }: { theme: ITheme }) => theme.invSideBarDropdownActiveBGHover} !important;
  }
  #DealersEditPage .sidenav .svg-inline--fa, 
  #InventoryEditPage .sidenav .svg-inline--fa, 
  #SignUpEditPage .sidenav .svg-inline--fa, 
  #LeadEditPage .sidenav .svg-inline--fa,
  #EmployeeEditPage .sidenav .svg-inline--fa,
  #CasesEditPage .sidenav .svg-inline--fa {
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
  }
  #DealersEditPage .sidenav .dropdown-container .nav-link, 
  #InventoryEditPage .sidenav .dropdown-container .nav-link, 
  #SignUpEditPage .sidenav .dropdown-container .nav-link, 
  #LeadEditPage .sidenav .dropdown-container .nav-link,
  #EmployeeEditPage .sidenav .dropdown-container .nav-link,
  #CasesEditPage .sidenav .dropdown-container .nav-link {
    background: ${({ theme }: { theme: ITheme }) => theme.invSideBarNavLinkBG};
    border-bottom: solid 1px ${({ theme }: { theme: ITheme }) => theme.invSideBarNavLinkBorder};
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
  }
  #DealersEditPage .sidenav a.nav-link:hover, 
  #InventoryEditPage .sidenav a.nav-link:hover, 
  #SignUpEditPage .sidenav a.nav-link:hover, 
  #LeadEditPage .sidenav a.nav-link:hover,
  #EmployeeEditPage .sidenav a.nav-link:hover,
  #CasesEditPage .sidenav a.nav-link:hover {
    background: ${({ theme }: { theme: ITheme }) => theme.invSideBarNavLinkBGHover} !important;
  }
  #DealersEditPage .sidenav button.dropdown-btn, 
  #InventoryEditPage .sidenav button.dropdown-btn, 
  #SignUpEditPage .sidenav button.dropdown-btn, 
  #LeadEditPage .sidenav button.dropdown-btn,
  #EmployeeEditPage .sidenav button.dropdown-btn,
  #CasesEditPage .sidenav button.dropdown-btn {
    background: ${({ theme }: { theme: ITheme }) => theme.invSideBarDropdownActiveBG};
    border-bottom: solid 1px ${({ theme }: { theme: ITheme }) => theme.invSideBarNavLinkBorder};
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
  }
  #DealersEditPage .sidenav button.dropdown-btn:hover, 
  #InventoryEditPage .sidenav button.dropdown-btn:hover, 
  #SignUpEditPage .sidenav button.dropdown-btn:hover, 
  #LeadEditPage .sidenav button.dropdown-btn:hover,
  #EmployeeEditPage .sidenav button.dropdown-btn:hover,
  #CasesEditPage .sidenav button.dropdown-btn:hover {
    background: ${({ theme }: { theme: ITheme }) => theme.invSideBarDropdownActiveBGHover};
  }
  #DealersEditPage .sidenav .nav-link, 
  #InventoryEditPage .sidenav .nav-link, 
  #SignUpEditPage .sidenav .nav-link, 
  #LeadEditPage .sidenav .nav-link,
  #EmployeeEditPage .sidenav .nav-link,
  #CasesEditPage .sidenav .nav-link {
    background: ${({ theme }: { theme: ITheme }) => theme.invSideBarNavLinkBG};
    border-bottom: solid 1px ${({ theme }: { theme: ITheme }) => theme.invSideBarNavLinkBorder};
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
  }
  @media (min-width: 1200px){
    .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute;
        background: ${({ theme }: { theme: ITheme }) => theme.navDropdownBG};
        min-width: 188px;
    }
  }
  .dropdown-item {
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
  }
  #drop-down-inventory-depth-2, #drop-down-leads-depth-2, #drop-down-sales-depth-2, #drop-down-cargurus-depth-2, #drop-down-myprofile-depth-2, #drop-down-general-depth-2, #drop-down-dealercarsearch-depth-2, #drop-down-craigslist-depth-2, #drop-down-exportsettings-depth-2, #drop-down-overview-depth-3, #drop-down-reviewsites-depth-3, #drop-down-reviewsites-depth-3, #drop-down-publicreviews-depth-3, #drop-down-privatefeedback-depth-3, #drop-down-locationperformance-depth-3, #drop-down-collect-depth-2, #drop-down-amplify-depth-2, #drop-down-howto-depth-2, #drop-down-trend-depth-4, #drop-down-reviewsites-depth-3, #drop-down-publicreviews-depth-3, #drop-down-privatefeedback-depth-3, #drop-down-locationperformance-depth-3, #drop-down-monitor-depth-2, #drop-down-campaignreports-depth-3, #drop-down-addcontacts-depth-3, #drop-down-customize-depth-3, #drop-down-tools-depth-3, #drop-down-responsemanager-depth-3, #drop-down-testimonials-depth-3, #drop-down-socialsharing-depth-3, #drop-down-funnel-depth-4, #drop-down-reputation-depth-2, #drop-down-locations-depth-4, #drop-down-locationgroups-depth-4 {
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
  }
  #NavBar .navbar-light .navbar-nav .nav-link {
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
  }
  .navbar {
    border-bottom: solid 1px ${({ theme }: { theme: ITheme }) => theme.border};
  }
  #NavBar .dropdown-item {
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
  }
  #NavBar .navbar-light .navbar-nav .active>.nav-link, #NavBar .navbar-light .navbar-nav .nav-link.active, #NavBar .navbar-light .navbar-nav .nav-link.show, #NavBar .navbar-light .navbar-nav .show>.nav-link {
    color: ${({ theme }: { theme: ITheme }) => theme.navActiveTextColor};
  }
  .dropdown-menu {
    --bs-dropdown-bg: ${({ theme }: { theme: ITheme }) => theme.navDropdownBG};
  }
  .dropdown-item:focus, .dropdown-item:hover {
    color: var(--white);
    background-color: var(--hoverBG);
  }
  // #####################################################################

  // Switch ##############################################################
  // .k-switch-on .k-switch-track {
  //   border-color: ${({ theme }: { theme: ITheme }) => theme.switchOnBorder};
  //   background-color: ${({ theme }: { theme: ITheme }) => theme.switchOnBG};
  // }
  // #####################################################################

  // Pricing Values ######################################################
  .table {
    --bs-table-color: ${({ theme }: { theme: ITheme }) => theme.pricingValuesTextColor};
    --bs-table-bg: ${({ theme }: { theme: ITheme }) => theme.pricingValuesBG};
    --bs-table-border-color: ${({ theme }: { theme: ITheme }) => theme.pricingValuesBorder};
  }
  // #####################################################################

  // Grid Buttons ########################################################
  .gridButton,
  .k-grid a.gridButton {
    color: ${({ theme }: { theme: ITheme }) => theme.gridButtonTextColor} !important;
    background-color: ${({ theme }: { theme: ITheme }) => theme.gridButtonBG} !important;
    border-color: ${({ theme }: { theme: ITheme }) => theme.gridButtonBorder}) !important;
  }
  .k-grid tr:hover a.gridButton {
    color: ${({ theme }: { theme: ITheme }) => theme.gridButtonTextColor} !important;
  }
  // #####################################################################

  //Cards #################################################################
  .cardHeader{
    background-color: ${({ theme }: { theme: ITheme }) => theme.cardHeaderBG} !important;
    color: ${({ theme }: { theme: ITheme }) => theme.textColor} !important;
  }
  .k-card {
    border-color: ${({ theme }: { theme: ITheme }) => theme.border} !important;
    color: ${({ theme }: { theme: ITheme }) => theme.textColor} !important;
    background-color: ${({ theme }: { theme: ITheme }) => theme.cardBG} !important;
  }
  .k-card-header {
    border-color: ${({ theme }: { theme: ITheme }) => theme.border} !important;
    color: ${({ theme }: { theme: ITheme }) => theme.textColor} !important;
    background-color: ${({ theme }: { theme: ITheme }) => theme.cardHeaderBG} !important;
  }
  .card-body {
    color: ${({ theme }: { theme: ITheme }) => theme.textColor} !important;
  }
  .card {
    color: ${({ theme }: { theme: ITheme }) => theme.textColor};
    --bs-card-border-color: ${({ theme }: { theme: ITheme }) => theme.border} !important;
  }
  // #####################################################################


  //Kendo Grid & other Kendo Items #######################################
  .k-grid {
    border-color: ${({ theme }: { theme: ITheme }) => theme.tableBorder} !important;
    color: ${({ theme }: { theme: ITheme }) => theme.textColor} !important;
    background-color: ${({ theme }: { theme: ITheme }) => theme.tableBG} !important;
  }

  .k-grid td, .k-grid .k-table-td, .k-grid .k-grid-content, .k-grid .k-grid-header-locked, .k-grid .k-grid-content-locked {
      border-color: ${({ theme }: { theme: ITheme }) => theme.tableBorder} !important;
  }

  .k-grid .k-table-alt-row {
    background-color: ${({ theme }: { theme: ITheme }) => theme.tableAltRowBG};
  }

  .k-table, .k-data-table {
    border-color: ${({ theme }: { theme: ITheme }) => theme.tableBorder} !important;
    color: ${({ theme }: { theme: ITheme }) => theme.textColor} !important;
    background-color: ${({ theme }: { theme: ITheme }) => theme.tableBG} !important;
  }

  .k-table-thead, .k-table-header, .k-table-group-sticky-header {
    border-color: ${({ theme }: { theme: ITheme }) => theme.tableBorder} !important;
    color: ${({ theme }: { theme: ITheme }) => theme.textColor} !important;
    background-color: ${({ theme }: { theme: ITheme }) => theme.tableHeaderBG} !important;
  }
  .k-listview {
    border-color: none;
    color: ${({ theme }: { theme: ITheme }) => theme.textColor} !important;
    background-color: transparent;
  }
  .k-pager {
      border-color: ${({ theme }: { theme: ITheme }) => theme.pagerBorder} !important;
      color: ${({ theme }: { theme: ITheme }) => theme.pagerTextColor} !important;
      background-color: ${({ theme }: { theme: ITheme }) => theme.pagerBG} !important;
  }
  .k-button-flat-primary {
    color: ${({ theme }: { theme: ITheme }) => theme.pagerNumberColor} !important;
  }
  // #####################################################################

  //Forms #################################################################
  .k-form, .k-form-inline {
    color: ${({ theme }: { theme: ITheme }) => theme.textColor} !important;
  }
  // #####################################################################

  //Chat #################################################################
  .k-chat {
    border-color: ${({ theme }: { theme: ITheme }) => theme.chatBorder};
    color: ${({ theme }: { theme: ITheme }) => theme.chatTextColor};
    background-color: ${({ theme }: { theme: ITheme }) => theme.chatBG};
  }
  .k-toolbar {
    border-color:  ${({ theme }: { theme: ITheme }) => theme.chatToolBarBorder};
    color: ${({ theme }: { theme: ITheme }) => theme.chatToolBarTextColor};
    background-color: ${({ theme }: { theme: ITheme }) => theme.chatToolBarBG};
  }
  // #####################################################################

  //Modal Windows ########################################################
  .modal-header {
    border-bottom: 1px solid ${({ theme }: { theme: ITheme }) => theme.modalBorder};
  }
  .modal-footer {
    border-top: 1px solid ${({ theme }: { theme: ITheme }) => theme.modalBorder};
  }
  .modal-content {
    background-color: ${({ theme }: { theme: ITheme }) => theme.modalBG};
    border: 1px solid ${({ theme }: { theme: ITheme }) => theme.modalBorder};
  }
  .modal .btn-close {
    --bs-btn-close-color: ${({ theme }: { theme: ITheme }) => theme.textColor};
  }
  .modal-title {
    color: ${({ theme }) => theme.textColor};
  }
  // #####################################################################

  //Kendo Tabs ########################################################
  .k-tabstrip-content, .k-tabstrip > .k-content {
    border-color: ${({ theme }: { theme: ITheme }) => theme.tabstripContentBorder};
    color: ${({ theme }: { theme: ITheme }) => theme.tabstripContentTextColor};
    background-color: ${({ theme }: { theme: ITheme }) => theme.tabstripContentBG};
  }
  // #####################################################################

  .logsHighlightColor {
    background-color: ${({ theme }: { theme: ITheme }) => theme.logsHighlightColor};
  }

  #LoginPage .input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
    margin-left: calc(var(--bs-border-width)* -1);
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background: ${({ theme }: { theme: ITheme }) => theme.loginPageInputGroup} !important;
    padding-top: 5px;
  }

`
